// extracted by mini-css-extract-plugin
export var bottomRightDock = "_14-0";